module.exports = __webpack_public_path__ + "img/annual.a19eb652.png";